import React from "react";
import { Avatar, Box, LinearProgress, Typography } from "@mui/material";
import { green } from "@mui/material/colors";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { UploadedImageProps } from "../../../types/interface";
import { VisonStudioImageOverlay } from "../../VisonStudioImageOverlay";
import { formatFileSize } from "../../../utils";

/**
 *
 * Component to display Uploaded Image
 * @param {object} UploadedImageProps
 * @property {number} progress
 * @property {Array<File>} files
 * @property {Array<string>} imageUrl
 *
 */

const UploadedImage: React.FC<UploadedImageProps> = ({
  progress,
  files,
  imageUrl,
}) => {
  const fileSize = files.map((item) => item.size).reduce((a, b) => a + b);

  return (
    <Box display="flex" alignItems="center" width="100%" flexDirection="column">
      <Box width="100%" display="flex" flexDirection="row" gap="30px">
        <Box display="contents">
          {imageUrl.length < 2 ? (
            <Avatar
              src={imageUrl[0]}
              alt="file image"
              variant="square"
              style={{ width: "20%", height: "auto", marginRight: 16 }}
            />
          ) : (
            <VisonStudioImageOverlay
              image1={imageUrl[0]}
              image2={imageUrl[1]}
            />
          )}
        </Box>
        <Box display="inline-grid" width="100%" ml="0.5rem">
          <Box
            display="flex"
            flexDirection="row"
            width="100%"
            justifyContent="space-between"
            alignItems="center"
          >
            <Box>
              <Typography variant="body1">
                {imageUrl.length} File{imageUrl.length === 1 ? "" : "s"}{" "}
                Uploading
              </Typography>
            </Box>
            <Box>
              {progress === 100 ? (
                <CheckCircleIcon sx={{ color: green[200] }} />
              ) : (
                ""
              )}
            </Box>
          </Box>
          <Typography variant="body2" color="textSecondary">
            {formatFileSize(fileSize)}
          </Typography>
        </Box>
      </Box>
      <Box width="100%" marginTop="10px">
        <Box display="flex" alignItems="center">
          <LinearProgress
            variant="determinate"
            value={progress}
            style={{ width: "100%", marginRight: 8 }}
          />
          <Typography
            variant="body2"
            color="textSecondary"
          >{`${progress}%`}</Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default UploadedImage;
